import { api } from '~config/api';

const getPages = (pageNumber) => api.get(`/v1/pages?page=${pageNumber}`);

export default {
  getPages
};
